import React, { Component } from 'react';
import { Route, Switch } from 'react-router';
import { Layout } from './components/Layout';
import { Estimate } from './components/Estimate';
import EstimateList from './components/EstimateList';
import { CostingDefaults } from './components/CostingDefaults';
import { PrintableHistory } from './components/PrintableHistory';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import PermissionManager from './PermissionManager/PermissionManager';
import IndustryManager from './components/Lookups/IndustryManager';
import RevenueRangeEditor from './components/Lookups/RevenueRangeEditor';
import './custom.css'

initializeIcons();
export default class App extends Component {
    static displayName = App.name;

    render() {
        return (
            <Layout>
                <Route exact path='/' component={EstimateList} />
                <Route path='/estimate/:id?' component={Estimate} />
                <Route path='/admin/costing' component={CostingDefaults} />
                <Route path='/admin/industries' component={IndustryManager} />
                <Route path='/admin/revenueRanges' component={RevenueRangeEditor} />
                <Route path='/printEstimate/:id' component={PrintableHistory} />
                <Route path='/admin' component={PermissionManager} />
            </Layout>
        );
    }
}
